import { initializeApp } from 'firebase/app'
import { getAuth, onIdTokenChanged } from 'firebase/auth'
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: process.env.VUE_APP_APIKEY,
    authDomain: process.env.VUE_APP_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_DATABASEURL,
    projectId: process.env.VUE_APP_PROJECTID,
    storageBucket: process.env.VUE_APP_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
    appId: process.env.VUE_APP_APIID,
    measurementId: process.env.VUE_APP_MEASUREMENTID
};

// init firebase
const app = initializeApp(firebaseConfig);


// init firebase auth
const auth = getAuth(app)

auth.getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = onIdTokenChanged(auth, (user) => {
            unsubscribe();
            resolve(user);
        }, reject);
    }
    )
};

// init firebase database
const database = getDatabase(app);

// init firebase functions
const functions = getFunctions(app);

// Initialize Analytics and get a reference to the service
const analytics = getAnalytics(app);

export { auth, database, functions, analytics }